export const SESSION_LOADING_SIGNING_IN = "Initializing Application ...";

export const SESSION_LOADING_UNABLE_TO_SIGN_IN =
  "Unable to verify your session, returning to sign-in.";
